import React, {useEffect, useState} from 'react';
import DraggableModal from "../UI/DraggableModal";
import {ProjectShort} from "../../models/Mng";
import useAPI from "../../hooks/useAPI";
import {Button, Modal} from "react-bootstrap";
import './TagProjectsModal.less'

interface TagProjectsModalProps{
    onHide: () => void,
    projects: ProjectShort[] | null,
}

export default function TagProjectsModal({onHide, projects}: TagProjectsModalProps) {
    const api = useAPI();

    return (
        <DraggableModal show={!!projects} onHide={onHide} headerNode='Проекты' size='lg'>
            <Modal.Body className='d-flex flex-column gap-3'>
                {projects?.map(proj => (
                    <div className='tagProject d-flex flex-column gap-1 pb-2' key={proj.id}>
                        <div className='d-flex gap-2'>
                            <span className='tagProject-name'>
                                {proj.fullNumber} {proj.name}
                            </span>
                            <span className='ms-auto' style={{fontSize: 12}}>
                                {proj.fullNumber[0] === '6' ? 'Политика ЦТ' : `СП${proj.fullNumber[0]}`}
                            </span>
                        </div>
                        <div style={{fontSize: 12, color: '#6c757d'}}>
                            Руководитель - {proj.head.displayName}
                        </div>
                    </div>
                ))}
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-end'>
                <Button variant='outline-primary' onClick={onHide}>OK</Button>
            </Modal.Footer>
        </DraggableModal>
    );
};
